export type BodyView = 'table' | 'dropzone' | 'empty' | 'error';

export type KnowledgeBaseLayoutSource = {
  isFileSystemEnabled: boolean;
  hasDocuments: boolean;
  isLoading: boolean;
  isError: boolean;
  hasNodes: boolean;
  isDrafting: boolean;
  hasActiveSearch: boolean;
  canWrite: boolean;
  isBucketRoot: boolean;
  hasSelection: boolean;
};

export type KnowledgeBaseLayout = {
  bodyView: BodyView;
  showToolbar: boolean;
};

const getBodyView = ({
  isFileSystemEnabled,
  hasDocuments,
  isLoading,
  isError,
  hasNodes,
  isDrafting,
  hasActiveSearch,
  canWrite,
  isBucketRoot,
}: KnowledgeBaseLayoutSource): BodyView => {
  // aiFileSystem cleanup: delete this branch.
  if (!isFileSystemEnabled) return hasDocuments ? 'table' : 'empty';

  if (isLoading) return 'table';
  if (isError) return 'error';

  // A draft row or a search with no hits still needs the table on screen.
  if (hasNodes || isDrafting || hasActiveSearch) return 'table';

  return canWrite && !isBucketRoot ? 'dropzone' : 'empty';
};

const isToolbarShown = (
  bodyView: BodyView,
  {
    isFileSystemEnabled,
    isBucketRoot,
    hasSelection,
  }: KnowledgeBaseLayoutSource,
): boolean => {
  if (bodyView === 'error') return false;

  if (isFileSystemEnabled && bodyView === 'empty') return false;

  return !isBucketRoot || hasSelection;
};

export const getKnowledgeBaseLayout = (
  source: KnowledgeBaseLayoutSource,
): KnowledgeBaseLayout => {
  const bodyView = getBodyView(source);

  return { bodyView, showToolbar: isToolbarShown(bodyView, source) };
};
